<template lang='pug'>
  blue-layout
    template(v-slot:default='props')
      bf-notice(@close='message = ""' :message='message')
      #merchants.view 
        header
          bf-wrapper
            h2 {{ $t('List of Merchants') }} 
            span ({{merchants.length}} Found)
          
        section.merchants
          bf-wrapper
            merchant-card( v-for='item in merchants' :item='item' :key='item.id' :user='{}' )
</template>

<script>
  import sort from '@/lib/sorters'
  import { View } from '@/mixins/view'
  import { db } from '@/main'
  import BaseCard from '@/components/base-card'
  import MerchantCard from '@/components/cards/merchant'

  export default {
    name: 'market.view',

    components: {
      MerchantCard
    },

    data() {
      return {
        message: '',
        merchants: [],
        referrals: [],
        username: this.$route.params.username
      }
    },

    firestore() {
      if ( !this.username ) return {
        merchants: {
          ref: db.collection( 'businesses' ).orderBy( 'name' ),
          resolve: sort.merchants
        }
      }
      else return {
        referrals: {
          ref: db.collection( 'referrals' ).where( 'by.username', '==', this.username ),
          resolve: docs => docs.forEach( doc => {
            if ( doc.type == 'friend' ) {
              db.collection( 'businesses' ).where( 'user_id', '==', doc.uid ).get().then( snap => {
                if ( !snap.docs[0].data().sample ) this.merchants.push( snap.docs[0].data() ) 
              })
            }
            else if ( doc.type == 'merchant-invitation' ) {
              let acc = doc.to
              db.collection( 'accounts' ).where( 'email', '==', acc.email ).get().then( snap => {
                let id = snap.docs[0].id
                console.log(id)  
                db.collection( 'businesses' ).where( 'user_id', '==', id ).get().then( snap => {
                  if ( !snap.docs[0] ) return
                  if ( !snap.docs[0].data().sample ) this.merchants.push( snap.docs[0].data() ) 
                })
              })
            }
            else {
              let acc = doc.to
              db.collection( 'businesses' ).where( 'user_id', '==', acc.id ).get().then( snap => {
                if ( !snap.docs[0] ) return
                if ( !snap.docs[0].data().sample ) this.merchants.push( snap.docs[0].data() ) 
              })
            }
          })
        },
        merchants: {
          ref: db.collection( 'businesses' ).orderBy( 'name' ),
          resolve: sort.merchants
        }
      }
    }
  }
</script>

<style scoped lang='stylus'>
  #merchants
    .inputs
      .bf-wrapper
        padding-top 0
        padding-bottom 0
        .bf-flex
          flex-wrap wrap
          select
            width auto
            margin-left 0
          input
            margin-right 8px
            min-width 50%
          select, input
            border 1px solid rgba( 0 0 0 .1 )
            border-radius 17px
            padding 8px 24px
          @media( max-width: 359px )
            flex-direction column-reverse
            align-items flex-start
            input
              width 100%
              margin-top 16px
    .merchants .bf-wrapper
      display grid
      grid-template-columns repeat( auto-fill, minmax( 360px, 1fr ) )
      grid-gap 32px
      @media( max-width: 420px )
        grid-template-columns 1fr
  .invite
    width 120px
    color rgb(255 255 255)
    font-size 1em
    padding 10px 15px 
    text-align center
    background #1F4590
    border-radius 5px
    margin-top 20px
    margin-bottom 5px

</style>
